// extracted by mini-css-extract-plugin
export var ccDetails = "savedCard-module--ccDetails--C8t72";
export var ccFieldx = "savedCard-module--ccFieldx--qeFrE";
export var ccPriText = "savedCard-module--ccPriText--qu8fE";
export var ccSecText = "savedCard-module--ccSecText--c1eG+";
export var emptyDiv = "savedCard-module--emptyDiv--xUGW+";
export var individulaElem = "savedCard-module--individulaElem--bYvvd";
export var paymentMethodLogos = "savedCard-module--paymentMethodLogos--Jery8";
export var rightTextSection = "savedCard-module--rightTextSection--lkhDF";
export var savedCardSection = "savedCard-module--savedCardSection--SyQcB";
export var singleCard = "savedCard-module--singleCard--yqxV-";